<!-- eslint-disable max-len -->
<template>
  <div>
    <Card title="Credit Purchase">
      <template v-slot:body>
        <div>
          <div class="pb-6 flex justify-between items-center">
            <div class="flex items-center">
              <div class="mr-2">
                <date-range-picker
                  ref="picker"
                  :timePicker="false"
                  :showDropdowns="false"
                  :max-date="maxDate"
                  v-model="dateRange"
                  :opens="'right'"
                  @update="onChangeDate"
                  :auto-apply="true"
                >
                  <template v-slot:input="picker" >
                    From: {{ moment(picker.startDate) }} - To: {{ moment(picker.endDate) }}
                  </template>
                </date-range-picker>
              </div>
              <div class="mr-2">
                <el-input placeholder="search user email" v-model="filter.q" @change="search" ></el-input>
              </div>
              <div class="mr-2">
                <el-select
                  filterable placeholder="Select Type"
                  v-model="filter.channel"
                >
                  <el-option :value="3" >Web Topup</el-option>
                  <el-option :value="2" >In-App Android</el-option>
                  <el-option :value="1" >In-App iOS</el-option>
                </el-select>
              </div>
              <Button @clicked="search" label="Apply"/>
              <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="reset" /></button>
            </div>
          </div>
        </div>
        <data-tables-server ref="tableTransaction" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTable" >
          <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import helperMixins from '../mixins/helpers.mixins';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';
import { Button } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';

const displayingItems = 50;

export default {
  name: 'CreditPurchasePage',
  mixins: [helperMixins],
  data() {
    return {
      isLoading: false,
      utc_offset: Math.floor(moment().utcOffset() / 60),
      data: [],
      total: 0,
      displayingItem: displayingItems,
      titles: [{
        prop: 'trx_ref',
        label: 'TRX ID',
      }, {
        prop: 'date',
        label: 'Date/Time',
      }, {
        prop: 'email',
        label: 'User Email',
      }, {
        prop: 'purchase_channel',
        label: 'Type',
      }, {
        prop: 'amount_credit',
        label: 'Credit Amount',
      }, {
        prop: 'amount_dollar_text',
        label: 'Paid Amount',
      }, {
        prop: 'fee_text',
        label: 'Fee',
      }, {
        prop: 'net_price_text',
        label: 'Net Amount',
      }, {
        prop: 'redemption_code',
        label: 'Redemption Code',
      }],
      filter: {
        page: 1,
        per_page: displayingItems,
        q: '',
        sortby: 'id',
        sortorder: 'desc',
        start_date: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        channel: '',
      },
      dateRange: {
        startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      maxDate: moment().format('YYYY-MM-DD'),
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListCreditPurchaseHistory(this.filter);
  },
  computed: {
    ...mapGetters('TransactionAdminModule', ['list_credit_purchase_history']),
  },
  watch: {
    list_credit_purchase_history: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (this.list_credit_purchase_history.data !== undefined) {
          this.data = this.list_credit_purchase_history.data.data.map(credit => ({ ...credit,
            amount_dollar_text: `${credit.final_currency} ${credit.final_amount ? this.formatPrice(credit.final_amount) : 0}`,
            net_price_text: `${credit.final_currency ? credit.final_currency : ''} ${credit.net_revenue ? this.formatPrice(parseFloat(credit.net_revenue).toFixed(2)) : '-'}`,
            fee_text: `${credit.final_currency ? credit.final_currency : ''} ${credit.fee ? this.formatPrice(parseFloat(credit.fee).toFixed(2)) : '-'}`,
            date: moment(credit.created_at).format('YYYY-MM-DD HH:mm:ss'),
          }));
          this.total = this.list_credit_purchase_history.data.total;
        }
      },
    },
  },
  methods: {
    ...mapActions('TransactionAdminModule', ['requestListCreditPurchaseHistory']),
    async search() {
      await this.requestListCreditPurchaseHistory(this.filterFormatUtc({}));
    },
    moment(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    filterFormatUtc(params){
      const startUtc = moment(this.filter.start_date).utc().format('YYYY-MM-DD HH:mm:ss');
      const endUtc = moment(this.filter.end_date).utc().format('YYYY-MM-DD HH:mm:ss');
      return {
        ...this.filter,
        ...params,
        start_date: startUtc,
        end_date: endUtc,
      }
    },
    async reset() {
      this.$refs.tableTransaction.$refs.elTable.clearSort();
      this.filter = {
        page: 1,
        per_page: this.displayingItem,
        sortby: 'id',
        sortorder: 'desc',
        q: '',
        start_date: '',
        end_date: '',
        channel: '',
      };
      this.search();
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter = Object.assign(this.filter, { per_page: this.displayingItem, sortorder, sortby, page });
      await this.requestListCreditPurchaseHistory(this.filterFormatUtc({}));
    },
    async onChangeDate(res) {
      this.filter = { ...this.filter,
        start_date: moment(res.startDate).format('YYYY-MM-DD'),
        end_date: moment(res.endDate).format('YYYY-MM-DD'),
      };
      // await this.search();
    },
  },
  components: {
    VueCustomTooltip, DateRangePicker,
    Button,
    Card,
  },
};
</script>
<style>
.daterangepicker .calendars{
  display:flex !important;
}
</style>
<style scoped>
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}
.vue-daterange-picker .reportrange-text{
  padding: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/views/CreditPurchase.vue